export default {
    pop: 'cubic-bezier(.64,1.95,.3,.81)',
};
